if (!customElements.get('product-form')) {
  const AUREME_CART_REFERRER_KEY = 'auremeCartReferrer';

  /*
   * カートページ遷移前に現在のページURLをsessionStorageに保存する。
   * cart.js / aureme-cart-enhancements.js がカートの「買い物を続ける」ボタンの遷移先として参照する。
   */
  function saveAuremeCartReferrer() {
    try {
      sessionStorage.setItem(AUREME_CART_REFERRER_KEY, window.location.href);
    } catch {
      /* Private Browsingなど書き込み不可の環境では無視 */
    }
  }

  function bindAuremeCartReferrerLink() {
    const cartReferrerLink = document.querySelector('[data-aureme-cart-referrer-link]');
    if (!cartReferrerLink || cartReferrerLink.dataset.auremeCartReferrerBound === 'true') return;

    cartReferrerLink.addEventListener('click', saveAuremeCartReferrer);
    cartReferrerLink.dataset.auremeCartReferrerBound = 'true';
  }

  bindAuremeCartReferrerLink();

  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.isAuremeProductForm = this.dataset.auremeProductForm === 'true';
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer'))
          this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const sectionsToRender = this.getSectionsToRender();
        if (sectionsToRender.length > 0) {
          formData.append('sections', sectionsToRender.join(','));
          formData.append('sections_url', window.location.pathname);
        }
        if (this.cart) {
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(routes.cart_add_url, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart && !this.isAuremeProductForm) {
              saveAuremeCartReferrer();
              window.location.assign(routes.cart_url);
              return;
            }

            if (!this.error) {
              const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              })
                .then(() => {
                  CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
                })
                .catch((error) => {
                  console.error(error);
                });
            }
            this.error = false;

            /*
             * AUREME PDP のフォームはミニカート（カート通知・ドロワー）を持たず、常にカートページへ
             * 遷移する仕様のため、カートアイコンのバブルだけ更新してから画面遷移する。
             * requestAnimationFrame は描画完了待ちではなく、バブル更新後の遷移処理を次フレームへ分けるために使う。
             */
            if (this.isAuremeProductForm) {
              CartPerformance.measure('add:paint-updated-sections', () => {
                this.updateCartIconBubble(response.sections?.['cart-icon-bubble']);
              });
              requestAnimationFrame(() => {
                saveAuremeCartReferrer();
                window.location.assign(routes.cart_url);
              });
              return;
            }

            this.cart?.setPresentation?.('default');
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure('add:paint-updated-sections', () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure('add:paint-updated-sections', () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
            window.AuremeToast?.show({
              message: 'カートへの追加に失敗しました。\nページを再読み込みしてお試しください。',
              type: 'error',
            });
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart?.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }

      getSectionsToRender() {
        if (this.isAuremeProductForm) {
          // ミニカートを描画しないため、Section Rendering API で取得するのもアイコンバブルだけでよい
          return ['cart-icon-bubble'];
        }

        return this.cart?.getSectionsToRender?.().map((section) => section.id) || [];
      }

      updateCartIconBubble(sectionHtml) {
        const cartIconBubble = document.getElementById('cart-icon-bubble');
        if (!cartIconBubble || !sectionHtml) return;

        const parsedHtml = new DOMParser().parseFromString(sectionHtml, 'text/html');
        const sectionElement = parsedHtml.querySelector('.shopify-section');
        if (!sectionElement) return;

        cartIconBubble.innerHTML = sectionElement.innerHTML;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    },
  );
}
